import { render } from "./SalesForce.vue?vue&type=template&id=8674d790&scoped=true"
import script from "./SalesForce.vue?vue&type=script&lang=js"
export * from "./SalesForce.vue?vue&type=script&lang=js"

import "./SalesForce.vue?vue&type=style&index=0&id=8674d790&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8674d790"]])

export default __exports__